<template>
  <b-container v-if="!isInitLoading">
    <div v-if="isValidLink">
      <div v-if="!form.isSubmit" class="payment-form">
        <b-row>
          <b-col>
            <div class="flex-center">
              <img alt="Logo" src="@/assets/logo.png" />
            </div>
          </b-col>
          <hr />
          <b-col cols="12" lg="12">
            <div class="mb-4">
              Have you paid Class 2 or Class 3 Voluntary contributions for the 2 most recent years?
            </div>
          </b-col>
          <b-col cols="12" lg="12">
            <label>Apr 2024 - Apr 2025</label>
            <div class="input-container">
              <b-form-select v-model="form.isApr2024" :options="yesNoOptions" :disabled="isSaveLoading"></b-form-select>
            </div>
          </b-col>
          <b-col cols="12" lg="12">
            <label>Apr 2025 - Apr 2026</label>
            <div class="input-container">
              <b-form-select v-model="form.isApr2025" :options="yesNoOptions" :disabled="isSaveLoading"></b-form-select>
            </div>
          </b-col>
          <hr />
          <b-col cols="12" lg="12">
            <label>How many years in a row did you live in the UK before leaving?</label>
            <div class="input-container">
              <b-form-select v-model="form.ukYears" :options="yearsOptions" :disabled="isSaveLoading"></b-form-select>
            </div>
          </b-col>
          <hr />
          <b-col cols="12" lg="12">
            <label>How many years of full National Insurance did you pay before leaving?</label>
            <div class="input-container">
              <b-form-select
                v-model="form.payNationalInsuranceYears"
                :options="payYearsOptions"
                :disabled="isSaveLoading"
              ></b-form-select>
            </div>
          </b-col>
          <template v-if="form.isShowJSA">
            <hr />
            <b-col cols="12" lg="12">
              <label>Were you receiving JobSeeker's Allowance immediately before you left UK?</label>
              <div class="input-container">
                <b-form-select
                  v-model="form.receivedJobSeekersAllowance"
                  :options="yesNoOptions"
                  :disabled="isSaveLoading"
                ></b-form-select>
              </div>
            </b-col>
            <template v-if="form.receivedJobSeekersAllowance">
              <b-col cols="12" lg="12"><label>Receive Child Benefit last date</label></b-col>
              <b-col cols="12" lg="12">
                <div class="input-container">
                  <b-form-input
                    v-model="form.receiveJSALastDate"
                    type="date"
                    @input="setTouched('receiveJSALastDate')"
                    :class="v$.form.receiveJSALastDate.$error ? 'is-invalid' : ''"
                    :disabled="isSaveLoading"
                    :max="todayDate"
                    min="1900-01-01"
                  ></b-form-input>
                  <div v-for="error of v$.form.receiveJSALastDate.$errors" class="invalid-feedback" :key="error.$uid">
                    {{ error.$message }}
                  </div>
                </div>
              </b-col>
            </template>
          </template>
          <template v-if="form.isShowChildBenefit">
            <hr />
            <b-col cols="12" lg="12">
              <label>Were you receiving Child Benefit before you left the UK?</label>
              <div class="input-container">
                <b-form-select
                  v-model="form.receivedChildBenefit"
                  :options="yesNoOptions"
                  :disabled="isSaveLoading"
                ></b-form-select>
              </div>
            </b-col>
            <template v-if="form.receivedChildBenefit">
              <b-col cols="12" lg="12"><label>Receive JSA last date</label></b-col>
              <b-col cols="12" lg="12">
                <div class="input-container">
                  <b-form-input
                    v-model="form.receiveChildBenefitLastDate"
                    type="date"
                    @input="setTouched('receiveChildBenefitLastDate')"
                    :class="v$.form.receiveChildBenefitLastDate.$error ? 'is-invalid' : ''"
                    :disabled="isSaveLoading"
                    :max="todayDate"
                    min="1900-01-01"
                  ></b-form-input>
                  <div
                    v-for="error of v$.form.receiveChildBenefitLastDate.$errors"
                    class="invalid-feedback"
                    :key="error.$uid"
                  >
                    {{ error.$message }}
                  </div>
                </div>
              </b-col>
            </template>
          </template>
          <b-col cols="12" lg="12">
            <template v-if="isSaveLoading">
              <div class="spinner-container p-3">
                <b-spinner></b-spinner>
              </div>
            </template>
            <div class="flex-center">
              <button class="btn-main" :disabled="isSaveLoading" @click="submitReapplyInfo">Submit</button>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else class="pay-completed-form">
        <b-row>
          <b-col>
            <div class="flex-center">
              <img alt="Logo" src="@/assets/logo.png" />
            </div>
          </b-col>
          <b-col cols="12" lg="12">
            <div class="flex-center">
              <h1>Thanks you!</h1>
              <p>Form submitted successfully.</p>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else class="invalid-container">
      <div class="flex-center">
        <img alt="Logo" class="p-3" src="@/assets/logo.png" />
        <h3 class="text-center">This link is not valid.</h3>
      </div>
    </div>
  </b-container>
  <b-container v-else>
    <b-row>
      <div class="flex-center">
        <div class="spinner-container p-3">
          <b-spinner></b-spinner>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { requiredIf, helpers } from '@vuelidate/validators';
import { toast } from 'vue3-toastify';
import '../HomeView/HomeView.scss';
import reapplyService from '@/services/reapply-service/reapply.service';
export default {
  computed: {
    isJSADateRequired() {
      return this.form.isShowJSA && this.form.receivedJobSeekersAllowance;
    },
    isChildBenefitDateRequired() {
      return this.form.isShowChildBenefit && this.form.receivedChildBenefit;
    },
    yearsOptions() {
      let result = [];
      for (let i = 1; i <= 30; i++) {
        result.push({ value: `${i}`, text: i });
      }
      return result;
    },
    payYearsOptions() {
      let result = [];
      for (let i = 0; i <= 30; i++) {
        result.push({ value: `${i}`, text: i });
      }
      return result;
    }
  },
  data() {
    return {
      recordId: null,
      v$: useVuelidate(),
      todayDate: new Date().toISOString().slice(0, 10),
      isInitLoading: true,
      isSaveLoading: false,
      form: {
        isSubmit: false,
        isApr2024: false, // 15q
        isApr2025: false,

        ukYears: '3', // 5 q
        payNationalInsuranceYears: '0', // 6 q

        isShowJSA: true, // 20 q
        receivedJobSeekersAllowance: false,
        receiveJSALastDate: null,

        isShowChildBenefit: true, // 21 q
        receivedChildBenefit: false,
        receiveChildBenefitLastDate: null
      },
      yesNoOptions: [
        { value: false, text: 'No' },
        { value: true, text: 'Yes' }
      ],
      isValidLink: false
    };
  },
  watch: {
    // Watch for changes to receivedJobSeekersAllowance
    'form.receivedJobSeekersAllowance': {
      handler(newValue) {
        if (!newValue && !this.isInitLoading) {
          // Reset to null when set to false
          this.form.receiveJSALastDate = null;
          // Reset validation state for this field
          this.v$.form.receiveJSALastDate.$reset();
        }
      }
    },
    // Watch for changes to receivedChildBenefit
    'form.receivedChildBenefit': {
      handler(newValue) {
        if (!newValue && !this.isInitLoading) {
          // Reset to null when set to false
          this.form.receiveChildBenefitLastDate = null;
          // Reset validation state for this field
          this.v$.form.receiveChildBenefitLastDate.$reset();
        }
      }
    }
  },
  validations() {
    return {
      form: {
        receiveJSALastDate: {
          requiredIf: helpers.withMessage(
            'Date required',
            requiredIf(() => {
              return this.form.isShowJSA && this.form.receivedJobSeekersAllowance;
            })
          ),
          minValue: helpers.withMessage('Invalid Date.', (value) => {
            if (!value) return true; // Skip validation if value is null/empty
            return new Date(value) > new Date('1900-01-01');
          }),
          maxValue: helpers.withMessage('Date not must be after today', (value) => {
            if (!value) return true; // Skip validation if value is null/empty
            return new Date(value) <= new Date();
          })
        },
        receiveChildBenefitLastDate: {
          requiredIf: helpers.withMessage(
            'Date required',
            requiredIf(() => {
              return this.form.isShowChildBenefit && this.form.receivedChildBenefit;
            })
          ),
          minValue: helpers.withMessage('Invalid Date.', (value) => {
            if (!value) return true; // Skip validation if value is null/empty
            return new Date(value) > new Date('1900-01-01');
          }),
          maxValue: helpers.withMessage('Date not must be after today', (value) => {
            if (!value) return true; // Skip validation if value is null/empty
            return new Date(value) <= new Date();
          })
        }
      }
    };
  },
  mounted() {
    if (this.$route?.params?.id) {
      this.recordId = this.$route?.params?.id;
      this.getReapplyInfo(this.recordId);
    } else {
      this.isValidLink = false;
    }
  },
  methods: {
    async getReapplyInfo(recordId) {
      try {
        const { status, reapply } = await reapplyService.getReapplyInfo(recordId);
        console.log('getReapplyInfo', status, reapply);
        if (status === 'success') {
          this.form = await this.formatData(reapply ?? {});
          this.isValidLink = true;
        } else {
          toast.error('Oops, Something Went Wrong');
        }
      } catch (err) {
        toast.error(err.message ?? 'Oops, Something Went Wrong');
        console.log(err);
        this.isValidLink = false;
      } finally {
        this.isInitLoading = false;
      }
    },
    formatData(reapply = {}) {
      return {
        isSubmit: reapply?.isSubmit ?? false,

        isApr2024: reapply?.isApr2024 ?? false,
        isApr2025: reapply?.isApr2025 ?? false,

        ukYears: reapply?.ukYears ?? '3',
        payNationalInsuranceYears: reapply?.payNationalInsuranceYears ?? '0',

        isShowJSA: reapply?.isShowJSA ?? false,
        receivedJobSeekersAllowance: reapply?.receivedJobSeekersAllowance ?? false,
        receiveJSALastDate: reapply?.receiveJSALastDate ?? null,

        isShowChildBenefit: reapply?.isShowChildBenefit ?? false,
        receivedChildBenefit: reapply?.receivedChildBenefit ?? false,
        receiveChildBenefitLastDate: reapply?.receiveChildBenefitLastDate ?? null
      };
    },
    setTouched(theModel) {
      if (theModel === 'receiveJSALastDate' || theModel == 'all') {
        this.v$.form.receiveJSALastDate.$touch();
      }
      if (theModel === 'receiveChildBenefitLastDate' || theModel == 'all') {
        this.v$.form.receiveChildBenefitLastDate.$touch();
      }
    },
    async submitReapplyInfo() {
      try {
        this.setTouched('all');
        if (!this.v$.$invalid) {
          this.isSaveLoading = true;
          const { status } = await reapplyService.submitReapplyInfo(this.recordId, this.form);
          if (status === 'success') {
            this.form.isSubmit = true;
          } else {
            toast.error('Oops, Something Went Wrong');
          }
        }
      } catch (error) {
        console.error(error);
        toast.error(error.message ?? 'Oops, Something Went Wrong');
      } finally {
        this.isSaveLoading = false;
      }
    }
  }
};
</script>
